import {collection, component, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";
import {DateTimeRangeData} from "../../datetime/date-time-range.data";

export class RecUserData extends EntityData<RecUserData> {
    @identifier userId: number;
    @field firstName: string;
    @field lastName: string;

    get name(): string {
        return this.firstName + " " + this.lastName;
    }
}

export class BreakData extends DateTimeRangeData<BreakData> {
}

export class ShiftData extends DateTimeRangeData<ShiftData> {
    @identifier shiftId: number;
    @collection(BreakData) breaks: BreakData[];
    @field outletId: number;
    @component recUser: RecUserData;
    @transientField hourField: string;

    @transientField get totalHours(): string {
        if (this.start && this.finish) {
            let sum: number = 0;
            if (this.breaks != null && this.breaks != undefined) {

                this.breaks.forEach((x) => {
                    if (x.finish && x.start) {
                        sum = sum + (x.finish.getTime() - x.start.getTime())
                    }

                })

            }
            const hours = Math.floor((this.finish.getTime() - this.start.getTime() - sum) / (1000 * 60 * 60));
            const mins = ((this.finish.getTime() - this.start.getTime() - sum) % (60 * 60 * 1000)) / (60 * 1000);
            this.hourField = hours + " hour(s), " + mins + "minute(s)"

        }
        return this.hourField;
    }

    set totalHours(hourField: string) {
        this.hourField = hourField;
    }
}
